import React from "react";

// Se elimina la interfaz ButtonProps

const ExportDataButtonPdf = ({ label, onClick, className = "", disabled = false }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`
                flex flex-col items-center justify-center
                text-center
                rounded-lg
                text-white
                hover:bg-blue-100
                transition-all duration-200
                shadow-md hover:shadow-lg
                disabled:bg-gray-400 disabled:cursor-not-allowed
                hover:bg-[rgba(09,127,159,0.2)]
            ${className}
        `}>
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 100 120">
                <rect x="10" y="10" width="80" height="100" rx="8" ry="8" fill="#ffffff" stroke="#D32F2F" strokeWidth="3" />
                <rect x="10" y="10" width="80" height="20" rx="4" ry="4" fill="#D32F2F" />
                <text x="50" y="25" fontFamily="Arial, sans-serif" fontSize="12" fill="#ffffff" textAnchor="middle">PDF</text>

                {/* PDF Icon / Logo */}
                <rect x="25" y="45" width="50" height="40" fill="#D32F2F" rx="4" ry="4" />
                <text x="50" y="70" fontFamily="Arial, sans-serif" fontSize="16" fill="#ffffff" fontWeight="bold" textAnchor="middle">PDF</text>

                {/* Lines at bottom */}
                <line x1="25" y1="95" x2="75" y2="95" stroke="#D32F2F" strokeWidth="2" />
                <line x1="25" y1="102" x2="60" y2="102" stroke="#D32F2F" strokeWidth="2" />
            </svg>
        </button>
    );
};

export default ExportDataButtonPdf;